var map = {
	"./3m.svg": "ebac",
	"./account-management.png": "a2bfb",
	"./bag.svg": "57b7",
	"./basket-1.png": "0b26",
	"./basket-1.svg": "559b",
	"./basket-product-remove.svg": "cb60",
	"./basket-product.png": "6bfa",
	"./business.png": "e7f1",
	"./card-visa.png": "51e3",
	"./check-red.svg": "458a",
	"./chevron-right.svg": "4672",
	"./curve.svg": "9841",
	"./dashboard.png": "461b",
	"./dashboard.svg": "57a8",
	"./dashboard1.svg": "44d9",
	"./dashboard_1.jpg": "c2ed",
	"./dashboard_2.jpg": "9089",
	"./db_1.svg": "e2fa",
	"./db_2.svg": "8171",
	"./dentoholic_logo.svg": "3c53",
	"./discount-bg.svg": "66d8",
	"./discount.svg": "54e8",
	"./easy_setup.svg": "7ee3",
	"./equipment-search.svg": "a712",
	"./equipment.svg": "6bcc",
	"./filter.svg": "5ee4",
	"./fonts/Gotham-Book.otf": "f2bf",
	"./fonts/Gotham-Light.otf": "d027",
	"./fonts/Gotham-Medium.otf": "f375",
	"./fonts/Gotham-Thin.otf": "7bc2",
	"./fonts/Gotham-Ultra.otf": "c458",
	"./fonts/GothamNarrow-Black.otf": "5ab4",
	"./fonts/GothamNarrow-Book.otf": "6e22",
	"./fonts/GothamNarrow-Thin.otf": "2dd0",
	"./fonts/GothamNarrow-Ultra.otf": "6bef",
	"./footer-img.svg": "2eac",
	"./guarantee.svg": "ace6",
	"./hero.svg": "88c7",
	"./increased_reach.svg": "bdd9",
	"./instruments-search.svg": "e7a7",
	"./instruments.svg": "dc0d",
	"./logo.svg": "9b19",
	"./mastercard.svg": "2112",
	"./materials-search.svg": "c83f",
	"./materials.svg": "a291",
	"./nsk.svg": "307b",
	"./order-confirmed.png": "d6b5",
	"./paypal.svg": "dbab",
	"./product-dashboard.svg": "84f3",
	"./product-detail.png": "26f0",
	"./product-logo.svg": "1508",
	"./product-sample.png": "276a",
	"./product-sub.png": "f372",
	"./promotion.svg": "6c24",
	"./risk_free.svg": "cd5f",
	"./sales-dashboard.png": "826e",
	"./stripe.svg": "0a37",
	"./supplier.png": "8ce6",
	"./tag.svg": "3928",
	"./tepe.svg": "5e1a",
	"./visa.svg": "0239",
	"./world-map.png": "aed2",
	"./yellow_check.svg": "5a7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";